module.exports = __webpack_public_path__ + "why13.png?23eab8c6613aae1eb4cc4256d35b5e36";